import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { WeightCounterComponent } from '../weight-counter/weight-counter.component';

import { socialCriterias } from '../../../configs/social-criteria.config';
import { SocialCriteriaForm } from '../../../models/season-create.model';
import { AbstractControl, FormControl, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SeasonFormGroup } from '../../../models/season-form.model';
import { SeasonBaseFormComponent } from '../season-base-form/season-base-form.component';
import { SeasonBaseFormHeaderComponent } from '../season-base-form/season-base-form-header/season-base-form-header.component';

@Component({
    selector: 'app-social-criteria',
    templateUrl: './social-criteria.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [WeightCounterComponent, ReactiveFormsModule, TranslateModule, SeasonBaseFormHeaderComponent]
})
export class SocialCriteriaComponent extends SeasonBaseFormComponent {
    public readonly socialCriteria = input<SeasonFormGroup['socialCriteria']>();

    public socialCriterias = socialCriterias;

    protected getFormControl(): AbstractControl {
        return this.socialCriteria();
    }

    public getCriterion(criterion: keyof SocialCriteriaForm): FormControl<number> {
        return this.socialCriteria().get(criterion) as FormControl<number>;
    }
}
